import { styled } from "@mui/material/styles";

// Container that holds both the Nav and the content
export const MainContainer = styled("div")(({ theme }) => ({
  display: "flex",
  flexDirection: "row",
  backgroundColor:
    theme.palette.mode === "light"
      ? theme.palette.grey[50]
      : theme.palette.background.default,
  color: theme.palette.text.primary,
  minHeight: "100vh",
  width: "100%",
  // Clip any descendant horizontal overflow at the root so a wide page can
  // never push the side nav off-screen or trigger a document-level scrollbar.
  overflowX: "clip",
}));

// Sits next to the side nav in MainContainer's flex row. flex: 1 fills the
// horizontal space; minWidth: 0 lets it shrink below its content's intrinsic
// width. height: 100vh gives its vertical-flex column children a fixed
// budget to share — without it, ContentContainer's flex:1 has nothing to
// resolve against.
export const TopNavAndContentContainer = styled("div")(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  padding: 0,
  flex: 1,
  minWidth: 0,
  height: "100vh",
}));

// flex:1 + minHeight:0 means: take whatever vertical room is left after
// TopNav (conditional) and ControlBanner (variable) take their natural sizes,
// and let inner content scroll within that. Replaces the old fixed
// `calc(100vh - 80px)` which assumed TopNav was always present and didn't
// react when ControlBanner toggled.
export const ContentContainer = styled("div")(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "stretch",
  paddingLeft: theme.spacing(2),
  paddingRight: theme.spacing(2),
  width: "100%",
  boxSizing: "border-box",
  minWidth: 0,
  backgroundColor:
    theme.palette.mode === "light"
      ? theme.palette.grey[50]
      : theme.palette.background.default,
  flex: 1,
  minHeight: 0,
  overflowY: "auto",
  overflowX: "hidden",
}));

export const NavContainer = styled("div")(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  // width: "225px",
  // width: props.collapsed ? "10vw" : "20vw",
  // [theme.breakpoints.down('sm')]: {
  //   width: "100px",
  // },
}));
